import { Button } from '@/components/ui/button';

import { Sidebar } from '../icons/Sidebar';
import { useSidebar } from '../ui/sidebar';

export default function SidebarTrigger() {
  const { setOpen, open, openMobile, setOpenMobile, isMobile } = useSidebar();

  return (
    <Button
      id="sidebar-trigger-button"
      onClick={() =>
        isMobile ? setOpenMobile(!openMobile) : setOpen(!open)
      }
      size="icon"
      variant="ghost"
      className="text-muted-foreground hover:text-muted-foreground"
    >
      <Sidebar className="!size-6" />
    </Button>
  );
}
